import { message } from "antd";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { getPreferences, updatePreferences } from "pages/api-clients/orgs";
import { useQueryToasterErrors } from "./useToaster";

const fastCache: { theme: "auto" | "light" | "dark" } = { theme: "auto" };

export function usePreferences() {
  const client = useQueryClient();
  const query = useQuery("preferences", async () => getPreferences());
  useQueryToasterErrors(query);
  if (query.isFetched) fastCache.theme = query.data?.theme || fastCache.theme;
  const mutator = useMutation({
    mutationFn: async ({
      theme,
      notifTimeout,
    }: {
      theme: typeof fastCache.theme;
      notifTimeout: number;
    }) => updatePreferences({ theme, notifTimeout }),
    onSuccess: async (data) => {
      message.success("Saved your UX preferences.");
      fastCache.theme = data.theme;
      client.invalidateQueries({ queryKey: "preferences" });
    },
    onError: () => {
      message.error(
        "There was a problem saving your preferences. Please refresh and try again."
      );
      client.invalidateQueries({ queryKey: "preferences" });
    },
  });
  return { query, mutator, theme: fastCache.theme };
}
